import { flashPackTheme } from '../../theme';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material';
import { LocaleProvider } from '../LocaleProvider/LocaleProvider';
import React, { ReactNode } from 'react';

interface LocaleAndThemeProviderProps {
  children: ReactNode;
}

const LocaleAndThemeProvider: React.FC<LocaleAndThemeProviderProps> = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={flashPackTheme}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <LocaleProvider>{children}</LocaleProvider>
        </LocalizationProvider>
      </MuiThemeProvider>
    </StyledEngineProvider>
  );
};

export default LocaleAndThemeProvider;
